import {
  GET_BUSINESS_MODELS_REQUEST,
  GET_BUSINESS_MODELS_SUCCESS,
  GET_BUSINESS_MODELS_FAIL,
  CREATE_BUSINESS_MODEL_REQUEST,
  CREATE_BUSINESS_MODEL_SUCCESS,
  CREATE_BUSINESS_MODEL_FAIL,
  UPDATE_BUSINESS_MODEL_REQUEST,
  UPDATE_BUSINESS_MODEL_SUCCESS,
  UPDATE_BUSINESS_MODEL_FAIL,
} from "../actions/types";

const initialState = {
  businessModels: [],
  loading: false,
  error: null,
};

export default function businessModelReducer(state = initialState, action) {
  switch (action.type) {
    case GET_BUSINESS_MODELS_REQUEST:
    case CREATE_BUSINESS_MODEL_REQUEST:
    case UPDATE_BUSINESS_MODEL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_BUSINESS_MODELS_SUCCESS:
      return {
        ...state,
        loading: false,
        businessModels: action.payload,
        error: null,
      };
    case CREATE_BUSINESS_MODEL_SUCCESS:
      return {
        ...state,
        loading: false,
        businessModels: [...state.businessModels, action.payload],
        error: null,
      };
    case UPDATE_BUSINESS_MODEL_SUCCESS:
      return {
        ...state,
        loading: false,
        businessModels: state.businessModels.map((model) =>
        model === action.payload.id ? action.payload : model
        ),
        error: null,
      };
    case GET_BUSINESS_MODELS_FAIL:
    case CREATE_BUSINESS_MODEL_FAIL:
    case UPDATE_BUSINESS_MODEL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}